const closingDay = [
  {
    day: 7,
    display: 1,
  },
  {
    day: 14,
    display: 2,
  },
  {
    day: 21,
    display: 3,
    startDaytime: '2023-12-26 10:00:00',
    endDaytime: '2024-01-05 10:00:00',
  },
]

export default closingDay
